/**
 * Convert the data from Difficulty into an object array
 *
 * @param entry
 * @returns {{easierTitle: "", easierList: [], harderTitle: "", harderList: []}[]}
 */
export default function getProgramFrequencyData(entry, t) {
  if (!entry || !entry.trainings) return null

  let data = ''

  if (entry.timesPerWeekCategory) {
    const frequencyLabel = entry.timesPerWeekCategory[0].title
    if (!entry.timesPerWeekCategory[0].title) return false

    const frequencyCount = parseInt(frequencyLabel.charAt(0))
    const weekCount = entry.trainings.length / frequencyCount
    const weekLabel = weekCount <= 1 ? t('DETAILCARD__WEEK') : t('DETAILCARD__WEEKS')
    const weekTotal = weekCount <= 1 ? 1 : Math.ceil(weekCount)

    data = `${weekTotal} ${weekLabel} - ${frequencyCount}${t('DETAILCARD__TIMESPERWEEK')}`
  }

  return data
}
